import axios from 'axios';
import config from '@/config';
import store from '../index';

class ExportApi {
  getExportList({ id }) {
    return axios({
      method: 'get',
      url: `${config.API_URL}/export/${id}/all`,
      headers: {
        Authorization: `Token ${store.getters.apikey}`,
      },
    }).then(response => response.data);
  }

  createExport({ id, type }) {
    return axios({
      method: 'post',
      url: `${config.API_URL}/studies/${id}/export`,
      headers: {
        Authorization: `Token ${store.getters.apikey}`,
      },
      data: {
        type,
      },
    }).then(response => response.data);
  }

  getExport({ id }) {
    return axios({
      method: 'get',
      url: `${config.API_URL}/export/${id}`,
      headers: {
        Authorization: `Token ${store.getters.apikey}`,
      },
    }).then(response => response.data);
  }

  patchExport({ id, payload }) {
    return axios({
      method: 'patch',
      url: `${config.API_URL}/export/${id}`,
      headers: {
        Authorization: `Token ${store.getters.apikey}`,
      },
      data: payload,
    }).then(response => response.data);
  }

  getExportLayout({ id }) {
    return axios({
      method: 'get',
      url: `${config.API_URL}/export/${id}/layout`,
      headers: {
        Authorization: `Token ${store.getters.apikey}`,
      },
    }).then(response => response.data);
  }

  getExportSiteMap({ id }) {
    return axios({
      method: 'get',
      url: `${config.API_URL}/export/${id}/map/sites`,
      headers: {
        Authorization: `Token ${store.getters.apikey}`,
      },
    }).then(response => response.data);
  }

  getExportSiteMapCollaborator({ id }) {
    return axios({
      method: 'get',
      url: `${config.API_URL}/export/${id}/map/collabos`,
      headers: {
        Authorization: `Token ${store.getters.apikey}`,
      },
    }).then(response => response.data);
  }

  getStudyLightview({ id }) {
    return axios({
      method: 'get',
      url: `${config.API_URL}/studies/${id}/lightview`,
      headers: {
        Authorization: `Token ${store.getters.apikey}`,
      },
    }).then(response => response.data);
  }

  patchExportLayout({ id, payload }) {
    return axios({
      method: 'patch',
      url: `${config.API_URL}/export/${id}/layout`,
      headers: {
        Authorization: `Token ${store.getters.apikey}`,
      },
      data: payload,
    }).then(response => response.data);
  }

  printExport({ id, language }) {
    return axios({
      method: 'post',
      url: `${config.API_URL}/export/${id}/print?language=${language}`,
      headers: {
        Authorization: `Token ${store.getters.apikey}`,
      },
    }).then(response => response.data);
  }

  getExportFile({ id }) {
    return axios({
      method: 'get',
      url: `${config.API_URL}/export/${id}/print`,
      headers: {
        Authorization: `Token ${store.getters.apikey}`,
      },
    }).then(response => response.data);
  }

  getExportExcel({ id }) {
    return axios({
      method: 'get',
      url: `${config.API_URL}/studies/${id}/excel`,
      responseType: 'arraybuffer',
      headers: {
        Authorization: `Token ${store.getters.apikey}`,
      },
    }).then(response => {
      const blob = new Blob([response.data], { type: response.headers['content-type'] });
      return { blob, name: response.headers['file-name'] };
    });
  }
}

export default new ExportApi();
